import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const UsersContainer = lazy(() =>
  import('@features/users/components/UsersContainer').then((module) => ({
    default: module.UsersContainer,
  }))
);

export const Route = createFileRoute('/_auth/users')({ component: UsersComponent });

function UsersComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <UsersContainer />
    </Suspense>
  );
}
